import axios from 'axios'
import Vue from 'vue'
import { API_ROOT } from '@/common/constants/'
import { encryptRequestParam, removeUserInfo } from '@/common/utils/common.js'
import toggleLoading from '@/components/loading/index.js'
import router from '@/router'
import store from '@/store'
import { errorList } from './errorList'

const showLoading = loadingDelay => {
  toggleLoading(true, loadingDelay || 0)
}
const closeLoading = () => {
  toggleLoading(false)
}
// 注册根实例
const instance = axios.create({
  baseURL: `${API_ROOT}/web.api`,
  withCredentials: false,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

instance.interceptors.request.use(
  function(config) {
    if (!config.notNeedLoading) {
      showLoading()
    }
    return config
  },
  function(error) {
    closeLoading()
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  function(response) {
    if (!response.config.notNeedLoading) {
      closeLoading()
    }
    if (response.status === 200 && response.data) {
      let stat = response.data.stat
      let list = stat ? stat.stateList : []
      if (stat.code !== 0) {
        Vue.prototype.$message.closeAll()
        let { message } = (errorList[String(stat.code)] && errorList[String(stat.code)]) || {}
        if (message) {
          Vue.prototype.$message({
            message,
            type: 'error'
          })
        }
        if ([-360, -300, -180, -160].includes(stat.code)) {
          store.dispatch('permission/clearRoutes')
          store.dispatch('tagsView/delAllViews')
          window.IM && window.IM.destroy()
          store.dispatch('user/logout')
        }
        if ([-390, -400].includes(stat.code)) {
          // -390 机构被切换 -400店铺被切换
          let shop = store.state.user.currentShop
          if (shop) {
            Vue.prototype
              .$confirm(
                `当前页面停留在${shop.shopName || shop.orgName}，您已被切换至新店铺，是否切换`,
                '提示',
                {
                  confirmButtonText: '留在当前店铺',
                  cancelButtonText: '去新店铺',
                  center: true
                }
              )
              .then(() => {
                store
                  .dispatch('user/changeUserShop', { orgId: shop.orgId, shopId: shop.id })
                  .then(() => {
                    Vue.prototype.$msgbox.close()
                    Vue.prototype.$message.success('切换店铺成功')
                    router.replace({
                      path: '/redirect' + router.currentRoute.fullPath
                    })
                  })
                  .catch(() => {
                    Vue.prototype.$msgbox.close()
                    Vue.prototype.$message.error('切换店铺失败')
                  })
              })
              .catch(() => {
                Vue.prototype.$msgbox.close()
                store.dispatch('tagsView/delAllViews')
                window.location.reload()
              })
          } else {
            Vue.prototype.$alert('您已被切换至新店铺', '提示', {
              confirmButtonText: '去新店铺',
              center: true,
              callback: function() {
                Vue.prototype.$msgbox.close()
                store.dispatch('tagsView/delAllViews')
                window.location.reload()
              }
            })
          }
          return { success: false, data: response.data }
        }
      } else if (list.length > 0 && list[0].code !== 0) {
        Vue.prototype.$message.closeAll()
        Vue.prototype.$message.closeAll()
        let message = list[0] && list[0].defaultTip
        let mesObj = errorList[String(list[0].code)]
        if (mesObj) {
          Vue.prototype.$message({
            message: mesObj.message,
            type: 'error'
          })
        } else if (message) {
          Vue.prototype.$message({
            message,
            type: 'error'
          })
        }
        return { success: false, data: response.data }
      } else {
        const systime = response.data.stat && response.data.stat.systime
        return { success: true, data: response.data.content, systime }
      }
    } else {
      return response
    }
  },
  function(error) {
    closeLoading()
    return Promise.reject(error)
  }
)

function post(name, data, config = {}) {
  return instance({
    ...config,
    method: 'post',
    data: encryptRequestParam({
      ...data,
      _mt: name
    })
  })
}

function get(name, data, config = {}) {
  return instance({
    ...config,
    method: 'get',
    params: encryptRequestParam({ ...data, _mt: name }, 'get')
  })
}
export { post, get }
